var map = {
	"./20251215-173624.gif": "10ff",
	"./3.9.png": "185b",
	"./365.png": "4863",
	"./back.png": "997e",
	"./back.svg": "26b9",
	"./button-left.png": "98df",
	"./button-right.png": "1515",
	"./button.png": "77d3",
	"./check.png": "7600",
	"./close.svg": "cb6c",
	"./close_black.svg": "27ef",
	"./co_branded.png": "333f",
	"./coffeeMachine.png": "32bc",
	"./coffeeWindChimes.mp3": "5767",
	"./collect-bg.png": "b6bf",
	"./cxwk-xr.png": "936f",
	"./cxwk.png": "5ab3",
	"./fruit_coffee.png": "08cb",
	"./generate-bg.png": "cd76",
	"./generate-content.png": "5331",
	"./home-button-mp3.mp3": "0812",
	"./home-button.gif": "e752",
	"./kjzy-xr.png": "227b",
	"./kjzy.png": "1ac6",
	"./left_bottom_prompt.png": "1ec8",
	"./loadingBg.jpg": "2f7a",
	"./milk_tea.png": "e007",
	"./morningCoffee.mp3": "64c5",
	"./music_play_icon.png": "30fa",
	"./new_product.png": "2df8",
	"./nezha_message_bac.png": "c1c6",
	"./no-check.png": "6dc5",
	"./page3_blur.png": "7d65",
	"./page3_table_bag.png": "16af",
	"./page4_blur.png": "d695",
	"./page4_store_bag.png": "4d2a",
	"./page5_blackboard_bac.png": "b892",
	"./page5_blur.png": "a7fb",
	"./page6_blur.png": "9a7f",
	"./page6_cumulative_bac.png": "44e8",
	"./page7_blur.png": "7d32",
	"./page7_coBranded_bac.png": "def7",
	"./page8_blur.png": "e4cd",
	"./page8_choice_bac.png": "e421",
	"./pause.png": "2d7c",
	"./play.png": "1606",
	"./rkhy-xr.png": "7ac7",
	"./rkhy.png": "7b03",
	"./tournament.png": "6892",
	"./trophy.png": "5e0b",
	"./up-arrow.png": "f7fa",
	"./warm_coffee.png": "d0c7",
	"./watermark.png": "c454",
	"./xiaoma_message_bac.png": "c9f7",
	"./yingtao_message_bac.png": "d77c",
	"./ysgr-xr.png": "936c",
	"./ysgr.png": "fba8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b3da";